module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-padding results blue-dk"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "grid-4"
  }, [_c('h2', [_vm._v("Calculate your recovery cost")]), _vm._v(" "), _c('div', {
    staticClass: "total-cost"
  }, [_vm._v(_vm._s(_vm._f("currency")(Math.floor(_vm.hourlyRevenueCost * (_vm.estimatedDowntime / 3600)))))]), _vm._v(" "), _c('div', {
    staticClass: "total-cost-label"
  }, [_vm._v("TOTAL COST TO BUSINESS")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-4 grid-offset-1"
  }, [_c('h3', [_vm._v("Recovery Process")]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "17px",
      "viewBox": "0 0 22 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-847.000000, -2892.000000)",
      "fill-rule": "nonzero",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Recovery-Process",
      "transform": "translate(845.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.125,85 L19.875,85 C22.153375,85 24,83.2093333 24,81 L2,81 C2,83.2093333 3.846625,85 6.125,85 Z M20,82 L21,82 L21,83 L20,83 L20,82 Z M22.625,68 L3.375,68 L2,79 L24,79 L22.625,68 Z",
      "id": "Shape"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.dataDisrupted) + " GB")]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Critical Systems Data")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-845.000000, -3009.000000)",
      "fill-rule": "nonzero",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Recovery-Process",
      "transform": "translate(845.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z M11,189 C11.276,189 11.5116667,189.097667 11.707,189.293 C11.9023333,189.488333 12,189.724 12,190 L12,195.586 L14.711,198.289 C14.9036667,198.481667 15,198.718667 15,199 C15,199.281333 14.9036667,199.518333 14.711,199.711 C14.5183333,199.903667 14.2813333,200 14,200 C13.7186667,200 13.4816667,199.903667 13.289,199.711 L10.289,196.711 C10.0963333,196.518333 10,196.281333 10,196 L10,190 C10,189.724 10.0976667,189.488333 10.293,189.293 C10.4883333,189.097667 10.724,189 11,189 Z",
      "id": "Shape"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("timeFormat")(_vm.timeBetweenBackups)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Time between backups")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-845.000000, -3009.000000)",
      "fill-rule": "nonzero",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Recovery-Process",
      "transform": "translate(845.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z M11,189 C11.276,189 11.5116667,189.097667 11.707,189.293 C11.9023333,189.488333 12,189.724 12,190 L12,195.586 L14.711,198.289 C14.9036667,198.481667 15,198.718667 15,199 C15,199.281333 14.9036667,199.518333 14.711,199.711 C14.5183333,199.903667 14.2813333,200 14,200 C13.7186667,200 13.4816667,199.903667 13.289,199.711 L10.289,196.711 C10.0963333,196.518333 10,196.281333 10,196 L10,190 C10,189.724 10.0976667,189.488333 10.293,189.293 C10.4883333,189.097667 10.724,189 11,189 Z",
      "id": "Shape"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("timeFormat")(_vm.timeInitiateBackup)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Recovery Process Initiation")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-845.000000, -3009.000000)",
      "fill-rule": "nonzero",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Recovery-Process",
      "transform": "translate(845.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z M11,189 C11.276,189 11.5116667,189.097667 11.707,189.293 C11.9023333,189.488333 12,189.724 12,190 L12,195.586 L14.711,198.289 C14.9036667,198.481667 15,198.718667 15,199 C15,199.281333 14.9036667,199.518333 14.711,199.711 C14.5183333,199.903667 14.2813333,200 14,200 C13.7186667,200 13.4816667,199.903667 13.289,199.711 L10.289,196.711 C10.0963333,196.518333 10,196.281333 10,196 L10,190 C10,189.724 10.0976667,189.488333 10.293,189.293 C10.4883333,189.097667 10.724,189 11,189 Z",
      "id": "Shape"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("timeFormat")(_vm.estimatedDowntime)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Estimated Downtime")])])]), _vm._v(" "), _c('div', {
    staticClass: "grid-3"
  }, [_c('h3', [_vm._v("Downtime Costs")]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "17px",
      "height": "17px",
      "viewBox": "0 0 17 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-1178.000000, -2895.000000)",
      "fill-rule": "nonzero",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Downtime-Costs",
      "transform": "translate(1175.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.015,81.031 C13.687,81.031 19.031,82.344 19.031,85.015 L19.031,87.031 L3,87.031 L3,85.015 C3,82.343 8.344,81.031 11.016,81.031 L11.015,81.031 Z M11.015,79.015 C8.812,79.015 7.031,77.234 7.031,75.031 C7.031,72.828 8.812,71 11.015,71 C13.218,71 14.999,72.828 14.999,75.031 C14.999,77.234 13.218,79.015 11.015,79.015 Z",
      "id": "Shape"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.affectedEmployees))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Employees Affected")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-1175.000000, -3009.000000)",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Downtime-Costs",
      "transform": "translate(1175.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z",
      "id": "Shape",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "id": "$",
      "font-family": "DattoDINExp-Bold, Datto DIN Exp",
      "font-size": "16",
      "font-style": "expanded",
      "font-weight": "bold"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "7",
      "y": "202"
    }
  }, [_vm._v("$")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.averageWage)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Average Employee Wage")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-1175.000000, -3009.000000)",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Downtime-Costs",
      "transform": "translate(1175.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z",
      "id": "Shape",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "id": "$",
      "font-family": "DattoDINExp-Bold, Datto DIN Exp",
      "font-size": "16",
      "font-style": "expanded",
      "font-weight": "bold"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "7",
      "y": "202"
    }
  }, [_vm._v("$")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.overheadCost)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Average Employee Overhead Cost")])]), _vm._v(" "), _c('div', {
    staticClass: "data-group"
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Artboard",
      "transform": "translate(-1175.000000, -3009.000000)",
      "fill": "#07F0D7"
    }
  }, [_c('g', {
    attrs: {
      "id": "Final-Calc",
      "transform": "translate(0.000000, 2612.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Downtime-Costs",
      "transform": "translate(1175.000000, 212.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11,185 C12.4946667,185 13.9203333,185.290333 15.277,185.871 C16.6336667,186.451667 17.803,187.233 18.785,188.215 C19.767,189.197 20.5483333,190.366333 21.129,191.723 C21.7096667,193.079667 22,194.505333 22,196 C22,197.494667 21.7096667,198.920333 21.129,200.277 C20.5483333,201.633667 19.767,202.803 18.785,203.785 C17.803,204.767 16.6336667,205.548333 15.277,206.129 C13.9203333,206.709667 12.4946667,207 11,207 C9.50533333,207 8.07966667,206.709667 6.723,206.129 C5.36633333,205.548333 4.197,204.767 3.215,203.785 C2.233,202.803 1.45166667,201.633667 0.871,200.277 C0.290333333,198.920333 5.32907052e-15,197.494667 0,196 C-5.32907052e-15,194.505333 0.290333333,193.079667 0.871,191.723 C1.45166667,190.366333 2.233,189.197 3.215,188.215 C4.197,187.233 5.36633333,186.451667 6.723,185.871 C8.07966667,185.290333 9.50533333,185 11,185 Z M11,187 C9.78133333,187 8.616,187.238333 7.504,187.715 C6.392,188.191667 5.435,188.831 4.633,189.633 C3.831,190.435 3.19166667,191.392 2.715,192.504 C2.23833333,193.616 2,194.781333 2,196 C2,197.218667 2.23833333,198.384 2.715,199.496 C3.19166667,200.608 3.831,201.565 4.633,202.367 C5.435,203.169 6.392,203.808333 7.504,204.285 C8.616,204.761667 9.78133333,205 11,205 C12.2186667,205 13.384,204.761667 14.496,204.285 C15.608,203.808333 16.565,203.169 17.367,202.367 C18.169,201.565 18.8083333,200.608 19.285,199.496 C19.7616667,198.384 20,197.218667 20,196 C20,194.781333 19.7616667,193.616 19.285,192.504 C18.8083333,191.392 18.169,190.435 17.367,189.633 C16.565,188.831 15.608,188.191667 14.496,187.715 C13.384,187.238333 12.2186667,187 11,187 L11,187 Z",
      "id": "Shape",
      "fill-rule": "nonzero"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "id": "$",
      "font-family": "DattoDINExp-Bold, Datto DIN Exp",
      "font-size": "16",
      "font-style": "expanded",
      "font-weight": "bold"
    }
  }, [_c('tspan', {
    attrs: {
      "x": "7",
      "y": "202"
    }
  }, [_vm._v("$")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.hourlyRevenueCost)))]), _vm._v(" "), _c('div', {
    staticClass: "data-label"
  }, [_vm._v("Hourly Revenue Cost")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a22759a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Results.vue
// module id = 36
// module chunks = 0